import * as Lib from './lib'
export const Translator = (issue = '') => {
    const dictionary = {
        // 'MISSING_HARDWARE': 'Missing Hardware',
        // 'MISSING_HANDLE_MODE': 'Select a hardware function',
        // 'MISSING_SWING_DIRECTION': 'Select a swing direction',
        // 'MISSING_JAMB': 'Missing Hardware',
    };
    return dictionary[issue] || Lib.humanize(issue.toLowerCase())
};